// @ts-nocheck
import React from 'react'
import { useNavigate } from 'react-router-dom';
import useFetch from '../../../../ApiClient/GetApi'
import { PostApi } from '../../../../ApiClient/PostApi';
import Header from "../../layout/Header";

export default function PaypalPaymentSuccess() {
    const navigate = useNavigate();
   
    window.onload = function () {
        document.getElementById('clickButton').click();
    }

    const paypal_payment_success = async () => {
        const res = await PostApi(`users/home/paypal_payment_success/${localStorage.getItem('orderId')}/${localStorage.getItem('transactionId')}`);
        if(res.data.status === "1")
        {
            localStorage.removeItem("orderId");
            localStorage.removeItem("transactionId");
        }
    }

    return (
        <>
            <section className="font-soehne">
                <Header />
                <section className="lg:py-20 py-12 xl:w-5/6 w-11/12 mx-auto">

                    <div className='p-20 bg-themeBlue text-center text-white text-3xl font-bold rounded-lg'>Thank You for Payment!</div>
                    <div className='flex justify-center mt-6'>
                    <button onClick={()=>navigate('/')} className='py-3 w-[370px] border border-themeBlue text-themeBlue rounded hover:text-white hover:bg-themeBlue'>Home</button>
                    </div>
                    
                    <button className='hidden' id="clickButton" type='button' onClick={() => paypal_payment_success()}>
                        Button
                    </button>
                </section>
            </section>

        </>
    )
}
